import { render, staticRenderFns } from "./CmgLoyaltyProgressWalletStickyHeader.vue?vue&type=template&id=866f0a9c&scoped=true&lang=pug&"
import script from "./cmg-loyalty-progress-wallet-sticky-header.ts?vue&type=script&lang=ts&"
export * from "./cmg-loyalty-progress-wallet-sticky-header.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLoyaltyProgressWalletStickyHeader.vue?vue&type=style&index=0&id=866f0a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866f0a9c",
  null
  
)

export default component.exports